import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Methods from "./components/Methods";
import Tutorial from "./components/Tutorial";
import Tools from "./components/Tools";
import Faq from "./components/Faq";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                name: "漫藏手册",
                description: "本子网站下载方式指南，整理打包下载、批量下载与离线下载教程。",
              },
              {
                "@type": "WebSite",
                name: "漫藏手册",
                description: "本子网站下载方式 - 本子打包下载、批量下载与离线下载教程",
                inLanguage: "zh-CN",
                url: "https://dlqzysm.cn/",
              },
              {
                "@type": "FAQPage",
                mainEntity: [
                  {
                    "@type": "Question",
                    name: "打包下载和批量下载有什么区别？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "打包下载是把整批资源压缩成单个文件一次性取用，适合整册收藏与归档；批量下载是把多本资源加入队列逐个拉取，适合边下边整理。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "离线下载一定要有离线空间吗？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "不一定。离线下载的核心是让下载不依赖本地网络波动，一般通过云端中转或下载器离线加速实现，网速稳定也可直接本地下载。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "为什么我的资源下载总是失败？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "绝大多数失败来自网络不稳定或本地存储空间不足。建议先清点空间，再用支持断点续传的下载器，大文件转入离线空间再转存。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "批量下载会不会漏掉某些资源？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "先在列表页统一勾选，再加入队列并核对队列数量是否与预期一致，可最大程度避免遗漏或重复。",
                    },
                  },
                  {
                    "@type": "Question",
                    name: "下载后文件很乱，该如何整理归档？",
                    acceptedAnswer: {
                      "@type": "Answer",
                      text: "用压缩与整理工具解压统一格式、批量重命名、按作者或系列建立目录，推荐采用作者_系列_标题的命名规范。",
                    },
                  },
                ],
              },
            ],
          }),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Methods />
        <Tutorial />
        <Tools />
        <Faq />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}